module.exports = __webpack_public_path__ + "static/downloadAppBack-115e628620ed16a9f445098e77499d11.png";